import { Component, computed, HostBinding, Inject, Input, OnInit} from "@angular/core";
import { NB_WINDOW, NbMenuItem, NbSidebarService, NbIconModule, NbMenuModule, NbButtonModule, NbUserModule } from "@nebular/theme";
import { Observable } from "rxjs";

import { NgdSearchComponent } from "../search/search.component";
import { Router, RouterLink } from "@angular/router";
import { NgIf, NgStyle } from "@angular/common";
import { StateService } from "../../../../../../app/@core/utils/state.service";
import { NbAuthService } from "../../../../../../app/authentication/services/auth.service";
import { NB_AUTH_OPTIONS } from "../../../../../../app/authentication/auth.options";
import { getDeepFromObject } from "../../../../../../app/authentication/helpers";
import { availableLanguages } from "../../../../../../app/interfaces/apiCalls";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { aboutUsPath, homePath, LOGIN_URL_PROFESSIONAL, navigateToLoginAndRedirectAfter, profileSlug, userLoginPath } from "docs/app/app.paths";
import { ApiService } from "../../../../../../app/services/api/api.service";
import { SelectPrincipalComponent } from "../../../../../../app/shared-components/select-principal/select-principal.component";

@Component({
  selector: "ngd-header",
  styleUrls: ["./header.component.scss"],
  templateUrl: "./header.component.html",
  standalone: true,
  imports: [NgIf, NbIconModule, RouterLink, NbMenuModule, NgdSearchComponent, NbButtonModule, TranslateModule, NgStyle, SelectPrincipalComponent, NbUserModule,  SelectPrincipalComponent],
})
export class NgdHeaderComponent implements OnInit {
  readonly profileSlug = profileSlug;
  @Input() showSearch = !!this.state.user;
  @HostBinding("class.docs-page") @Input() isDocs = false;
  strategy: string = "";
  navigateToLoginAndRedirectAfter = navigateToLoginAndRedirectAfter

  isOnLoginPage = computed(() => this.router.url.includes(userLoginPath()));
  isOnIndexPage = computed(() => this.router.url === '/');


  private window: Window;
  currentVersionName$: Observable<string>;
  showVersionSelect$: Observable<boolean>;

  mainMenu: NbMenuItem[] = [];

  // mainMenu: NbMenuItem[] = [
  //   {
  //     title: 'hhPlatform.home.menu.home',
  //     link: '/signup/professional',
  //   },
  //   {
  //     title: this.translate.instant('hhPlatform.home.menu.partner'),
  //     link: '/docs/components/components-overview',
  //   },
  //   {
  //     title: this.translate.instant('hhPlatform.home.menu.aboutUs'),
  //     link: '/docs/design-system/eva-design-system-intro',
  //   },
  //   {
  //     title: this.translate.instant('hhPlatform.home.menu.resources'),
  //     link: '/docs/auth/introduction',
  //   },
  //  /*  {
  //     title: 'infrastruktur',
  //     link: '/docs/security/introduction',
  //   }, */
  // ];

  @Input() sidebarTag: string;

  constructor(
    @Inject(NB_WINDOW) window,
    @Inject(NB_AUTH_OPTIONS) protected options = {},
    private sidebarService: NbSidebarService,
    public state: StateService,
    protected service: NbAuthService,
    public translate: TranslateService,
    public router: Router,
    private api: ApiService,
  ) {
    this.window = window;
    this.strategy = this.getConfigValue("forms.logout.strategy");
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }

  ngOnInit() {


    // if (!this.isDocs) {
    //   this.mainMenu.push({
    //     title: this.translate.instant(
    //       "hhPlatform.home.menu.professionalServices"
    //     ),
    //     link: "/docs/getting-started/professional-services",
    //   });
    // }
    const mainMenuTranslationsKeys = [
      "hhPlatform.home.menu.home",
      "hhPlatform.home.menu.partner",
      "hhPlatform.home.menu.aboutUs",
      // "hhPlatform.home.menu.resources",
      "hhPlatform.home.menu.professionalServices"
    ];

    // we do it this way to avoid issues with async loading of translations
    this.translate.get(mainMenuTranslationsKeys).subscribe((translation) => {
      this.mainMenu = [
        {
          title: translation["hhPlatform.home.menu.home"],
          link: homePath(),
        },
        {
          title: translation["hhPlatform.home.menu.aboutUs"],
          link: aboutUsPath(),
        },
        // {
        //   title: translation["hhPlatform.home.menu.resources"],
        //   link: "/docs/auth/introduction",
        // },
        // dynamically display something based on the input isDocs condition, if necessary:
      /*   ...(this.isDocs? []: [
          {
            title: translation["hhPlatform.home.menu.professionalServices"],
            link: "/docs/getting-started/professional-services"
          }
        ] ) */
      ];
    });
  }

  logout() {
    this.router.navigate(["/f/logout"]);
  }

  redirectToSignup() {
    this.window.location.href = LOGIN_URL_PROFESSIONAL;
  }

  toggleSidebar() {
    this.sidebarService.toggle(false, this.sidebarTag);
  }

  async useLanguage(language: availableLanguages): Promise<void> {
    this.translate.use(language);
    // localStorage.setItem('language', language);
    if (this.state.getUser()) {
      try {
        await this.api.setUserLanguage(language);
      } catch (e) {
        console.deverror('Could not save language preference:', e);
      }
    } else {
      localStorage.setItem('language', language);
    }
    window.location.reload();
  }

  }
